<template>
    <router-link :to="route" :class="{ 'is-active': isActive }" @click="closeMenu"> Course Dashboard </router-link>
</template>

<script>
import ActiveStatusMixin from '@/mixins/ActiveStatus.mixin.js';
import Course from '@/models/Course.js';

export default {
    name: 'CourseDashboard',

    mixins: [ActiveStatusMixin],

    props: {
        closeMenu: {
            type: Function,
            default: () => {},
        },

        course: {
            type: Course,
            required: true,
        },
    },

    computed: {
        notInProgress() {
            return !this.course.in_progress;
        },

        route() {
            return {
                name: 'course-dashboard',
                params: {
                    courseId: this.course.id,
                },
            };
        },
    },
};
</script>
